<template>
	<v-row dense align="center">
		<v-col>
			<v-row dense>
				<v-col>
					<v-text-field
						v-model="externalId"
						outlined
						dense label="Prontuário"
						placeholder="Prontuário não informado"
						:readonly="true" />
				</v-col>
				<v-col cols="8">
					<v-text-field v-model="name" outlined dense label="Nome" :readonly="true"
						placeholder="Nome do paciente não informado" />
				</v-col>
			</v-row>

			<v-row dense>
				<v-col>
					<v-text-field v-model="birthDate" outlined dense label="Data de Nascimento" :readonly="true"
						placeholder="Data de Nascimento não informada" v-mask="'##/##/####'" />
				</v-col>
				<v-col>
					<v-text-field v-model="gender" outlined dense label="Sexo"
						placeholder="Sexo não informado" :readonly="true" />
				</v-col>

				<v-col>
            <v-text-field
              v-model="vip"
              outlined
              dense
              label="VIP"
              placeholder="VIP não informado"
              :readonly="true"
            />
        </v-col>  
			</v-row>

			<v-row gutters="10" dense>
          <v-col>
            <v-text-field
              v-model="motherName"
              outlined
              dense
              label="Nome da Mãe"
              placeholder="Nome do mãe não informado"
              :readonly="true"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="fatherName"
              outlined
              dense
              label="Nome da Pai"
              placeholder="Nome do pai não informado"
              :readonly="true"
            />
          </v-col>
      </v-row>

      <v-row gutters="10" dense>
        <v-col>
            <v-text-field
              v-model="maritalStatus"
              outlined
              dense
              label="Estado Civil"
              placeholder="Estado Civil não informado"
              :readonly="true"
            />
        </v-col>
        <v-col>
          <v-text-field
            v-model="skinColor"
            outlined
            dense
            label="Cor"
            placeholder="Cor não informado"
            :readonly="true"
          />
        </v-col>
      </v-row> 

			
      <v-row gutters="10" dense>
        <v-col>
          <v-text-field
            v-model="cpf"
            outlined
            dense
            label="CPF"
            placeholder="CPF não informado"
            v-mask="'###.###.###-##'"
            :readonly="true"
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="rgDivision"
            outlined
            dense
            label="Orgão Emissor"
            placeholder="Orgão Emissor não informado"
            :readonly="true"
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="rg"
            outlined
            dense
            label="RG"
            placeholder="RG não informado"
            :readonly="true"
          />
        </v-col> 
      </v-row> 

			<v-row gutters="10" dense>
        <v-col>
          <v-text-field
            v-model="cep"
            outlined
            dense
            label="CEP"
            placeholder="CEP não informado"
            :readonly="true"
          />
        </v-col>
        <v-col cols="7">
          <v-text-field
            v-model="street"
            outlined
            dense
            label="Rua"
            placeholder="Rua não informado"
            :readonly="true"
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="number"
            outlined
            dense
            label="Número"
            placeholder="Número não informado"
            :readonly="true"
          />
        </v-col>
      </v-row>
  
        <v-row gutters="8" dense>
          <v-col cols="">
            <v-text-field
              v-model="neighborhood"
              outlined
              dense
              label="Bairro"
              placeholder="Bairro não informado"
              :readonly="true"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="nationality"
              outlined
              dense
              label="Nacionalidade"
              placeholder="Nacionalidade não informado"
              :readonly="true"
            />
          </v-col>
        </v-row>
  
        <v-row gutters="10" dense>
          <v-col cols="6">
            <v-text-field
              v-model="descriptionCity"
              outlined
              dense
              label="Cidade"
              placeholder="Cidade não informada"
              :readonly="true"
            />
          </v-col>
        
          <v-col>
            <v-text-field
              v-model="stateAcronym"
              outlined
              dense
              label="Estado"
              placeholder="Estado não informada"
              :readonly="true"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="descriptionCountry"
              outlined
              dense
              label="Pais"
              placeholder="Pais não informado"
              :readonly="true"
            />
          </v-col>
        </v-row>
  
        <v-row
          no-gutters
          v-for="contactPatient in patientData.contacts"
          :key="contactPatient.id"
        >
          <v-col>
            <PatientContact :contact="contactPatient" />
          </v-col>
        </v-row> 
		</v-col>
	</v-row>
</template>

<script>
import PatientContact from "@/components/queues/attendance/patient_contact.vue";
import GET_PATIENT_DATA from "@/graphql/patients/patient_data.gql";

export default {
	name: "PatientIndex",
  components: {
    PatientContact,
  },
	data() {
		return {
			patientId: "",
			externalId: "",
			name: "",
			birthDate: "",
			gender: "",
			motherName: "",
			fatherName: "",
      maritalStatus: "",
      skinColor: "",
      vip: "",
      cpf: "",
      rgDivision: "",
      rg: "",
      cep: "",
      street: "",
      number: "",
      neighborhood: "",
      nationality: "",
      descriptionCity: "",
      stateAcronym: "",
      descriptionCountry: "",
		};
	},
	created() {
		if (this.$route.params.patientId) {
			this.patientId = this.$route.params.patientId;
		}
		this.$apollo.queries.patientData.refetch();
	},
	mounted() {
		this.$apollo.queries.patientData.refetch();
	},
	apollo: {
		patientData: {
			query: GET_PATIENT_DATA,
			deep: true,
			variables() {
				return {
					patientId: this.patientId,
				};
			},
			skip() {
			return this.patientId === "";
			},
			result({ data }) {
				this.externalId = data.patientData?.externalId
				this.name = data.patientData?.name
        this.vip = data.patientData?.vip == true ? "Sim" : "Não"
				this.birthDate = this.$moment.utc(new Date(this.patientData?.birthDate)).format("DD/MM/YYYY");
				this.gender = data.patientData?.gender?.description
				this.motherName = data.patientData?.motherName
				this.fatherName = data.patientData?.fatherName
        this.maritalStatus = data.patientData?.maritalStatus?.description
        this.skinColor = data.patientData?.skinColor?.description
        this.cpf = data.patientData?.cpf
        this.rgDivision = data.patientData?.rgDivision
        this.rg =  data.patientData?.rg
        this.cep = data.patientData?.address.cep
        this.street = data.patientData?.address.street
        this.number = data.patientData?.address?.number
        this.neighborhood = data.patientData?.address?.neighborhood
        this.nationality = data.patientData?.address?.nationality
        this.descriptionCity = data.patientData?.address?.city.description
        this.stateAcronym = data.patientData?.address?.city?.state.acronym
        this.descriptionCountry = data.patientData?.address?.city?.state.country.description
			}
		},
	},
}


</script>
